import React from "react";
import PrivacyPolicyDetails from "./condition-details/PrivacyPolicyDetails";

const PrivacyPolicy = () => {
  return (
    <div className="container-fluid conditions-fluid bg-common">
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-xl-9 col-lg-9 mx-auto">
            <PrivacyPolicyDetails />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
